export const MEETING_STATUS = {
  PENDING: 1,
  CONFIRMED: 2,
  DECLINED: 3,
  CANCELLED: 4,
  EXPIRED: 5,
}
